<template>
  <div
    :data-widget-title="content.optionalTitle?.text"
    :class="{ 'mask-arc-t bg-white': content.backgroundColor === 'white' }"
  >
    <div
      class="container grid gap-6 lg:grid-cols-sidebar lg:items-center pt-16 md:pt-20 pb-8 lg:pb-20"
    >
      <div class="px-box-4">
        <SliceTitle class="title sm:text-left" :value="content.optionalTitle" />
        <PortableText class="typography" :content="content.content" />
        <a
          v-if="content.optionalCta"
          class="btn btn-amber mt-6"
          :href="content.optionalCta.link ?? undefined"
        >
          {{ content.optionalCta.label }}
        </a>
      </div>
      <div class="overflow-x-auto lg:overflow-visible">
        <ul class="flex lg:flex-col">
          <li
            v-for="(item, index) in content.featuredBlocks"
            :key="index"
            class="flex flex-col shrink-0 shadow-2 rounded-10 w-80 lg:w-full p-8 my-4 ml-1 mr-4 text-center"
          >
            <img
              v-if="item.icon?.url"
              class="shrink-0 h-9 self-center -mb-3 object-contain"
              :src="item.icon.url"
              :alt="item.icon.alt ?? ''"
            />
            <PortableText class="typography text-16" :content="item.text" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GQLTextBlocksSlice } from './generated/text-blocks'

defineProps<{ content: GQLTextBlocksSlice }>()
</script>
